// extracted by mini-css-extract-plugin
module.exports = {"navigation":"Settings_navigation__XvTP-","navigation_item":"Settings_navigation_item__1mgy4","navigation_item_active":"Settings_navigation_item_active__VaTGt"};